<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="交易渠道ID"
                prop="channelsid"
              >
                <Input
                  v-model="formValidate.channelsid"
                  placeholder="请输入交易渠道ID"
                ></Input>
              </FormItem>
              <FormItem
                label="费用"
                prop="amount"
              >
                <Input
                  v-model="formValidate.amount"
                  placeholder="请输入费用"
                ></Input>
              </FormItem>
              <FormItem
                label="状态参数"
                prop="status"
              >
                <el-select
                  v-model="formValidate.status"
                  filterable
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="类型参数"
                prop="type"
              >
                <el-select
                  v-model="formValidate.type"
                  filterable
                  default-first-option
                  placeholder="请选择类型">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="备注"
                prop="remark"
              >
                <Input
                  v-model="formValidate.remark"
                  placeholder="请输入备注"
                ></Input>
              </FormItem>
              <FormItem
                label="支付时间"
                prop="pay_time"
              >
                <DatePicker type="date" editable v-model="formValidate.pay_time" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择支付时间"></DatePicker>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getCostinfolist,
  operationCostinfo
} from '@/api/cost/costinfo.js'
import {getsysparameterList} from '@/api/system/sys_parameter'

let moment = require('moment')
export default {
  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      statusList: [],
      typeList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        channelsid: [
          {
            required: true,
            message: '交易渠道ID不能为空',
            trigger: 'blur'
          }
        ],
        amount: [
          {
            required: true,
            message: '费用不能为空',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ],
        remark: [
          {
            required: true,
            message: '备注不能为空',
            trigger: 'blur'
          }
        ],
        pay_time: [
          {
            required: true,
            type: 'date',
            message: '请选择支付时间',
            trigger: 'change'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '交易渠道ID',
          key: 'channelsid',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '费用',
          key: 'amount',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '状态',
          key: 'status_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '类型',
          key: 'type_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '备注',
          key: 'remark',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '支付时间',
          key: 'pay_time',
          width: 130,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    getCostinfolist (key, value) {
      this.spinShow = true
      getCostinfolist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
      getsysparameterList('cost_info', 'status').then(res => {
        if (res.data.code === 0) {
          this.statusList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('cost_info', 'type').then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          channelsid: paramsRow.channelsid,
          amount: paramsRow.amount,
          status: paramsRow.status,
          type: paramsRow.type,
          remark: paramsRow.remark,
          pay_time: paramsRow.pay_time
        }
      } else {
        this.formValidate = {
          id: 0,
          channelsid: '',
          amount: '',
          status: '',
          type: '',
          remark: '',
          pay_time: s2
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.pay_time = moment(this.formValidate.pay_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationCostinfo(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getCostinfolist(this.searchVal)
                } else {
                  this.getCostinfolist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationCostinfo({'id_list': this.tableSelectIdList}, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getCostinfolist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationCostinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getCostinfolist(this.searchVal)
      } else {
        this.getCostinfolist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getCostinfolist(this.searchVal)
      } else {
        this.getCostinfolist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getCostinfolist(this.searchVal)
      } else {
        this.getCostinfolist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getCostinfolist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
